module.exports = __webpack_public_path__ + "static/media/trash.e1fd8e87.svg";